exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.canopy-list-renderer {\n  border: 1px solid #efefef;\n  border-radius: 10px;\n  padding: 20px;\n  background: white;\n  margin-top: 20px; }\n.canopy-list-renderer .renderer-title {\n    font-size: 18px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/copy-offer-dialog/copy-offer-dialog.component.scss
// module id = ../../../../../src/app/shared/components/copy-offer-dialog/copy-offer-dialog.component.scss
// module chunks = main